const DEFAULT_MESSAGE = "Problem rendering component";

function Fallback({ message = DEFAULT_MESSAGE }: { message: string }) {
  return <div className="text-instant-teams-red-Main">{message}</div>;
}

export default Fallback;
